import axios from 'axios';

import { setSession } from '../utils';
import { STORAGE_KEY } from '../enums';

export const API_URL = process.env.REACT_APP_COMMON_PROFILE_API_URL;

// ----------------------------------------------------------------------

export const axiosAuthInstance = axios.create({ baseURL: API_URL });

let accessToken = localStorage.getItem("token");

axiosAuthInstance.defaults.headers.common['Accept-Language'] = '';
axiosAuthInstance.defaults.headers.common.Authorization = `${accessToken}`; //`Bearer ${accessToken}`;

axiosAuthInstance.interceptors.response.use(
  (res) => res,
  (error) => {
    try {
      if(error.response.status == 401){
        setSession(null, null, null, false);
        window.location.href = '/';
      }
    } catch(err) {}

    return Promise.reject((error.response && error.response.data) || 'Something went wrong')
  }
);

export default axiosAuthInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosAuthInstance.get(url, { ...config });

  return res.data;
};
